
<div @click="toggle" class="headerCheckbox" :class="{'checked': checked}"><i class="heart icon"></i></div>
